<template>
    <div style="display: inline;">
        <section class="institutes py-5 bg-sub-secondary-color institutes-page">
            <div class="container-fluid">
                <div v-if="checkEmployeeDiscount()" class="employee-discount text-center ">
                    <form :action="apply_employee_discount_url">
                        <input type="hidden" name="keyword" :value="keyword.replace(tra.institute, '')">
                        <input type="hidden" name="country_id" :value="country_id">
                        <input type="hidden" name="country_slug" :value="country_slug">
                        <input type="hidden" name="city_id" :value="city_id">
                        <input type="hidden" name="course_weeks" :value="course_weeks">
                        <input type="hidden" name="best_offers" :value="best_offers">
                        <input type="hidden" name="course_level" :value="course_level">
                        <input type="hidden" name="student_id" :value="student_id">
                        <input type="hidden" name="sorting" :value="sorting">
                        <input type="hidden" name="category_type" :value="category_type">
                        <input type="hidden" name="category_intensity" :value="category_intensity">
                        <input type="hidden" name="study_period" :value="study_period">
                        <input type="hidden" name="start_date" :value="formatDate(start_date)">
                        <input type="hidden" name="need_residence" :value="need_residence">
                        <input type="hidden" name="residence_type" :value="residence_type">
                        <input type="hidden" name="bath_type" :value="bath_type">
                        <input type="hidden" name="visa" :value="visa">
                        <input type="hidden" name="insurance" :value="insurance">
                        <input type="hidden" name="need_airport" :value="need_airport">
                        <input type="hidden" name="institute_class" :value="institute_class">
                        <input type="hidden" name="budget" :value="budget">
                        <input type="hidden" name="institutes_page" :value="1">
                        <input v-if="remove_discount == 1" type="hidden" name="remove_discount" value="1">

                        <div class="ml-4 d-inline-flex align-items-center">
                            {{ tra.employee_discount }}
                            <input class="mr-2" type="number" :max="employee_discount_type == 'percentage' ? 100 : ''"
                                v-model="employee_dsicount" name="employee_dsicount">
                        </div>
                        <div class="ml-4 d-inline-flex align-items-center">
                            <span class="d-inline-flex align-items-center mx-3">
                                {{ tra.percentage }}
                                <input class="mr-2" @change="change_employee_discount_type()"
                                    v-model="employee_discount_type" value="percentage" type="radio"
                                    name="employee_discount_type" style="height: 15px; width: 15px;">
                            </span>
                            <span class="d-inline-flex align-items-center">
                                {{ tra.fixed_value }}
                                <input class="mr-2" @change="change_employee_discount_type()"
                                    v-model="employee_discount_type" value="fixed" type="radio"
                                    name="employee_discount_type" style="height: 15px; width: 15px;">
                            </span>
                        </div>
                        <div type="submit" class="ml-4 d-inline-flex align-items-center">
                            <button class="ml-xl-4 btn rounded-10 bg-secondary-color text-white"> {{ tra.apply_discount
                                }} </button>
                            <button @click="remove_discount = 1" class="ml-xl-4 btn rounded-10 bg-danger text-white">
                                {{ tra.cancel_discount }} </button>
                        </div>
                    </form>
                    <hr>
                </div>
                <div class="row px-xl-5 align-items-center">
                    <div class="col-md-4">
                        <div class="heading-institutes">
                            <h3 class="text-main-color font-weight-bold h4">
                                {{ tra.english_language_institutes }}
                                <span v-if="country_id && countries.length > 0">
                                    {{ tra.in }}
                                    {{countries.find(country => country.id == country_id).name}}
                                    {{city_id && cities.length > 0 ? ', ' + cities.find(city => city.id == city_id).name
                                        : ''}}
                                </span>
                                ( {{ courses.total }} )
                            </h3>
                            <p v-if="country_id && countries.length > 0">
                                {{ tra.browse_best_institutes_in }}
                                {{countries.find(country => country.id == country_id).name}}
                                {{city_id && cities.length > 0 ? ', ' + cities.find(city => city.id == city_id).name :
                                    ''}}
                            </p>
                            <p v-else>
                                {{ tra.browse_institutes_text }}
                            </p>
                        </div>
                    </div>
                    <div class="col-md-4 text-center">


                        <DiscountToggle v-if="this.admin && app_name == 'sat-edu'" :admin="this.admin"
                            :discountLabel="tra.sat_discount_label" :url="active_sat_discount_url"
                            :for="'active_sat_discount'" @discount-changed="onDiscountChanged" />

                        <DiscountToggle v-if="this.admin && app_name == 'sat-edu'" :admin="this.admin"
                            :appName="app_name" :discountLabel="tra.hidden_discount_label"
                            :url="active_sat_discount_url" :for="'active_hidden_discount'"
                            @discount-changed="onDiscountChanged" />
                        <DiscountToggle v-if="this.admin && app_name == 'sat-edu'" :admin="this.admin"
                            :appName="app_name" :discountLabel="tra.institute_discount" :url="active_sat_discount_url"
                            :for="'active_institute_discount'" @discount-changed="onDiscountChanged" />



                    </div>
                    <div :class="'col-md-4 ' + (lang == 'ar' ? 'text-md-left text-right' : 'text-md-right text-left')">

                        <button @click="copyPageLink()"
                            class="ml-xl-4 btn rounded-10 bg-secondary-color text-white toast-btn"
                            target="copy-page-link">
                            {{ tra.share_page_link }}
                            <i class="fas fa-share-alt mr-2"></i>
                        </button>
                    </div>
                    <div class="toast-parent" id="copy-page-link">
                        <div class="toast-box">
                            <div class="bg-white p-4 rounded-10 mb-4 toast-custom-body">
                                <div class="text-center">
                                    <div class="cheched-img">
                                        <img :src="public_path +
                                            'website/imgs/checked.png'
                                            " alt="" width="70px" class="img-fluid" />
                                    </div>
                                    <h3 class="text-main-color font-weight-bold">
                                        {{ tra.link_copied_success }}
                                    </h3>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="row px-xl-5 mb-5 institutes-filter">
                    <div class="col-xl-3">
                        <div id="accordion" class="sticky-top pt-4">
                            <div class="card rounded-10 shadow-sm mb-4">
                                <div class="card-header border-bottom bg-white rounded-10 border-0 d-flex justify-content-between"
                                    id="headingOne">
                                    <h5 class="font-weight-bold text-main-color">
                                        {{ tra.search_institute }}
                                    </h5>
                                    <button class="toggel-filter-btn btn rounded-10 bg-secondary-color text-white"
                                        data-toggle="collapse" data-target="#collapseOne" aria-expanded="true"
                                        aria-controls="collapseOne">
                                        {{ tra.close }}
                                    </button>
                                </div>
                                <div id="collapseOne" class="collapse show" aria-labelledby="headingOne"
                                    data-parent="#accordion">
                                    <div class="card-body border-top">
                                        <form
                                            v-on:submit.prevent="filter_courses(); pagination_pages_method(courses.current_page);"
                                            action="">
                                            <label>{{ tra.enter_institute_or_city }}</label>
                                            <div class="input-group mb-3 border rounded-10 pl-3 pr-2 btn-light">
                                                <input v-model="keyword"
                                                    @keyup.enter="filter_courses(); pagination_pages_method(courses.current_page);"
                                                    type="text" class="form-control border-0 bg-transparent pr-1"
                                                    :placeholder="tra.search" />
                                                <div class="input-group-append">
                                                    <span class="input-group-text border-0 p-0 bg-transparent"
                                                        id="basic-addon2"><i class="fas fa-search"></i></span>
                                                </div>
                                            </div>
                                            <div v-if="app_name === 'sat-edu'" class="form-group">
                                                <label>{{ tra.course_language }}</label>
                                                <select v-model="course_language_id" class="form-control rounded-10">
                                                    <option value="">{{ tra.all_languages }}</option>
                                                    <option v-for="lang in course_languages" :key="lang.id" :value="lang.id">{{ lang.name }}</option>
                                                </select>
                                            </div>
                                            <div class="form-group">
                                                <label>{{ tra.choose_country }}</label>
                                                <select name="country_id" @change="changeCountryId = true"
                                                    v-model="country_id" class="form-control rounded-10">
                                                    <option hidden value="">{{ tra.country }}</option>
                                                    <option value="">{{ tra.all_countries }}</option>
                                                    <option v-for="country in countries" :key="country.id"
                                                        :value="country.id">{{ country.name }}</option>
                                                </select>
                                            </div>
                                            <div class="form-group">
                                                <label>{{ tra.choose_city }}</label>
                                                <select name="city_id" v-model="city_id"
                                                    class="form-control rounded-10">
                                                    <option value="">{{ tra.choose_city }}</option>
                                                    <option value="">{{ tra.all_cities }}</option>
                                                    <option v-for="city in cities" :key="city.id" :value="city.id">{{
                                                        city.name }}</option>
                                                </select>
                                            </div>
                                             

                                            <template v-if="app_name === 'langtour'">
                                                <div class="form-group">
                                                    <label>{{ tra.course_type }}</label>
                                                    <select v-model="category_type" class="form-control rounded-10">
                                                        <option value="">{{ tra.choose_course_category }}</option>
                                                        <option value="general_engliash">{{ tra.general_english_course
                                                            }}
                                                        </option>
                                                        <option value="bussines_engliash">{{ tra.business_english_course
                                                            }}</option>
                                                        <option value="ielts">{{ tra.ielts_preparation_course }}
                                                        </option>
                                                        <option value="tofel">{{ tra.tofel_preparation_course }}
                                                        </option>
                                                        <option value="cambridge">{{ tra.cambridge_preparation_course }}
                                                        </option>
                                                        <option value="one_to_one">{{ tra.one_to_one_course }}</option>
                                                        <option value="summer">{{ tra.summer_courses }}</option>
                                                    </select>
                                                </div>
                                                <div class="form-group">
                                                    <label>{{ tra.course_language }}</label>
                                                    <select v-model="course_language_id" class="form-control rounded-10">
                                                        <option value="">{{ tra.all_languages }}</option>
                                                        <option v-for="lang in course_languages" :key="lang.id" :value="lang.id">{{ lang.name }}</option>
                                                    </select>
                                                </div>
                                                <div class="form-group">
                                                    <label>{{ tra.study_time }}</label>
                                                    <select v-model="study_period" class="form-control rounded-10">
                                                        <option value="">{{ tra.choose_study_time }}</option>
                                                        <option value="morning">{{ tra.morning }}</option>
                                                        <option value="afternoon">{{ tra.afternoon }}</option>
                                                    </select>
                                                </div>
                                            </template>
                                            

                                            <div class="collaps-at-md">
                                                <div class="form-group">
                                                    <label>{{ tra.weeks_number }}</label>
                                                    <select v-model="course_weeks" class="form-control rounded-10">
                                                        <option v-for="week in 52" :key="week" :value="week">{{ week }}
                                                        </option>
                                                    </select>
                                                </div>
                                                <div class="form-group">
                                                    <p v-if="(Date.parse(start_date) + course_weeks * 7 * 24 * 60 * 60 * 1000) > Date.parse('01/01/2025')"
                                                        class="text-sm mb-1 text-danger">
                                                        {{ tra.prices_may_vary }}
                                                    </p>
                                                    <label>{{ tra.start_date }}</label>
                                                    <DatePicker v-model="start_date" name="start_date"
                                                        :disabledDays="[0, 2, 3, 4, 5, 6]" :minDate="new Date()"
                                                        icon="pi pi-calendar" size="small" dateFormat="dd-mm-yy"
                                                        class="w-100" @date-select="setCurrentTime" />

                                                </div>
                                                <div class="form-group">
                                                    <label>{{ tra.do_you_need_accommodation }}</label>
                                                    <select v-model="need_residence" class="form-control rounded-10">
                                                        <option value="">{{ tra.do_you_need_accommodation }}</option>
                                                        <option value="yes">{{ tra.yes_need_accommodation }}</option>
                                                        <option value="no">{{ tra.no_need_accommodation }}</option>
                                                    </select>
                                                </div>
                                                <!-- <div v-if="need_residence == 'yes' && app_name !== 'langtour'"
                                                    class="form-group">
                                                    <label>{{ tra.age }}</label>
                                                    <select v-model="residence_age" class="form-control rounded-10">
                                                        <option value="">{{ tra.please_select }}</option>
                                                        <option value="under_16">{{ tra.under_16 }}</option>
                                                        <option value="16">{{ tra.age_16 }}</option>
                                                        <option value="17">{{ tra.age_17 }}</option>
                                                        <option value="18_and_above">{{ tra.age_18_and_above }}</option>
                                                    </select>
                                                </div> -->
                                                <div v-if="need_residence == 'yes'" class="form-group">
                                                    <label>{{ tra.choose_accommodation_type }}</label>
                                                    <select v-model="residence_type" class="form-control rounded-10">
                                                        <option value="">{{ tra.choose_accommodation_type }}</option>
                                                        <option value="student_housing">{{ tra.student_housing }}
                                                        </option>
                                                        <option value="family_accommodation">{{ tra.family_accommodation
                                                            }}</option>
                                                        <option value="private_studio">{{ tra.private_studio }}</option>
                                                        <option value="all">{{ tra.all }}</option>
                                                    </select>
                                                </div>
                                                <div v-if="need_residence == 'yes'" class="form-group">
                                                    <label>{{ tra.bathroom_type }}</label>
                                                    <select v-model="bath_type" class="form-control rounded-10">
                                                        <option value="">{{ tra.bathroom_type }}</option>
                                                        <option value="private_bathroom">{{ tra.private_bathroom }}
                                                        </option>
                                                        <option value="shared_bathroom">{{ tra.shared_bathroom }}
                                                        </option>
                                                        <option value="all">{{ tra.all }}</option>
                                                    </select>
                                                </div>
                                                <div class="form-group">
                                                    <label>{{ tra.do_you_need_insurance }}</label>
                                                    <select v-model="insurance" class="form-control rounded-10">
                                                        <option value="">{{ tra.do_you_need_insurance }}</option>
                                                        <option value="yes">{{ tra.yes_need_insurance }}</option>
                                                        <option value="no">{{ tra.no_need_insurance }}</option>
                                                    </select>
                                                </div>
                                                <div class="form-group">
                                                    <label>{{ tra.airport_pickup }}</label>
                                                    <select v-model="need_airport" class="form-control rounded-10">
                                                        <option value="">{{ tra.need_airport_pickup }}</option>
                                                        <option value="yes">{{ tra.yes }}</option>
                                                        <option value="no">{{ tra.no }}</option>
                                                    </select>
                                                </div>
                                                <div v-if="[14, 24, 19, 15, 22, 25, 23].includes(Number(country_id)) && app_name !== 'langtour'"
                                                    class="form-group">
                                                    <label>{{ tra.do_you_need_visa }}</label>
                                                    <select v-model="visa" class="form-control rounded-10">
                                                        <option value="">{{ tra.do_you_need_visa }}</option>
                                                        <option value="yes">{{ tra.yes_need_visa }}</option>
                                                        <option value="no">{{ tra.no_need_visa }}</option>
                                                    </select>
                                                </div>

                                                <template v-if="app_name !== 'langtour'">
                                                    <div class="form-group" v-if="category_type != 'summer'">
                                                        <label>{{ tra.course_intensity }}</label>
                                                        <select v-model="category_intensity"
                                                            class="form-control rounded-10">
                                                            <option value="">{{ tra.choose_course_intensity }}</option>
                                                            <option value="normal">{{ tra.normal }}</option>
                                                            <option value="semi_intensive">{{ tra.semi_intensive }}
                                                            </option>
                                                            <option value="intensive">{{ tra.intensive }}</option>
                                                            <option value="high_intensive">{{ tra.high_intensive }}
                                                            </option>
                                                        </select>
                                                    </div>
                                                    <div class="form-group">
                                                        <label>{{ tra.course_type }}</label>
                                                        <select v-model="category_type" class="form-control rounded-10">
                                                            <option value="">{{ tra.choose_course_category }}</option>
                                                            <option value="general_engliash">{{
                                                                tra.general_english_course }}
                                                            </option>
                                                            <option value="bussines_engliash">{{
                                                                tra.business_english_course }}
                                                            </option>
                                                            <option value="ielts">{{ tra.ielts_preparation_course }}
                                                            </option>
                                                            <option value="tofel">{{ tra.tofel_preparation_course }}
                                                            </option>
                                                            <option value="cambridge">{{
                                                                tra.cambridge_preparation_course }}
                                                            </option>
                                                            <option value="one_to_one">{{ tra.one_to_one_course }}
                                                            </option>
                                                            <option value="summer">{{ tra.summer_courses }}</option>
                                                        </select>
                                                    </div>
                                                   
                                                    <div class="form-group">
                                                        <label>{{ tra.study_time }}</label>
                                                        <select v-model="study_period" class="form-control rounded-10">
                                                            <option value="">{{ tra.choose_study_time }}</option>
                                                            <option value="morning">{{ tra.morning }}</option>
                                                            <option value="afternoon">{{ tra.afternoon }}</option>
                                                        </select>
                                                    </div>
                                                </template>

                                                <div class="form-group">
                                                    <label>{{ tra.sort_by }}</label>
                                                    <select v-model="sorting" class="form-control rounded-10">
                                                        <option value="">{{ tra.all }}</option>
                                                        <option v-for="sorting in courses_sorting" :key="sorting.name"
                                                            :value="sorting.value">
                                                            {{ sorting.name }}
                                                        </option>
                                                    </select>
                                                </div>
                                                <div v-if="this.admin" class="form-group">
                                                    <label>{{ tra.institute_rating }}</label>
                                                    <select v-model="institute_class" class="form-control rounded-10">
                                                        <option value="">{{ tra.all }}</option>
                                                        <option value="1">{{ tra.grade_a_plus }}</option>
                                                        <option value="2">{{ tra.grade_a }}</option>
                                                        <option value="3">{{ tra.grade_b }}</option>
                                                        <option value="4">{{ tra.grade_c }}</option>
                                                        <option value="5">{{ tra.grade_d }}</option>
                                                        <option value="6">{{ tra.grade_e }}</option>
                                                        <option value="none"></option>
                                                    </select>
                                                </div>
                                                <div class="form-group">
                                                    <label>{{ tra.your_budget }}</label>
                                                    <input
                                                        @change="filter_courses(); pagination_pages_method(courses.current_page);"
                                                        type="number" v-model="budget" class="form-control rounded-10">
                                                </div>
                                            </div>

                                            <div class="text-center mt-md-3 mt-1 d-md-none">
                                                <a class="btn rounded-10 bg-main-color text-white mb-2 w-100 mt-3"
                                                    data-toggle="collapse" href="#moreOptions" role="button"
                                                    aria-expanded="false" aria-controls="moreOptions">
                                                    {{ tra.more_options }}
                                                </a>
                                            </div>

                                            <button
                                                @click="filter_courses(); pagination_pages_method(courses.current_page); hide_search_fields()"
                                                type="button"
                                                :class="['btn rounded-10', app_name === 'langtour' ? 'bg-main-color' : 'bg-secondary-color', 'text-white mb-2 w-100 mt-3']">
                                                {{ tra.search }}
                                            </button>
                                        </form>
                                    </div>
                                </div>
                            </div>
                            <nav aria-label="Page navigation" class="d-lg-none d-block">
                                <div class="row" dir="ltr">
                                    <div class="col-md-auto col-12 order-md-1 order-2">
                                        <ul class="pagination d-flex justify-content-center p-0 m-0">
                                            <li class="m-0">
                                                <span>
                                                    <span class="page-link rounded-10 mx-1 bg-dark text-white border-0">
                                                        {{ tra.page }}
                                                        {{
                                                            courses.current_page
                                                        }}
                                                        {{ tra.of }}
                                                        {{ courses.last_page }}
                                                    </span>
                                                </span>
                                            </li>
                                        </ul>
                                    </div>
                                </div>
                            </nav>
                        </div>
                    </div>
                    <div class="col-xl-9">
                        <div class="institutes-list pt-4 position-relative" id="institutes-box">
                            <div class="ajax_loader">
                                <img :src="public_path + 'storage/ajax_loder.gif'
                                    " />
                            </div>
                            <div v-if="courses.data != ''" class="row">
                                <div v-for="course_info in courses.data" :key="course_info.course.course_id"
                                    class="col-lg-4 col-md-6">
                                    <div class="card mx-0 shadow-sm offer border-0 institute-card rounded-10 mb-4">
                                        <div v-if="course_info.course.sat_discount > 0 && app_name == 'sat-edu'"
                                            class="offer-icon sat-discount position-absolute">
                                            {{ tra.sat_discount_label }} -{{ course_info.course.sat_discount * 100 }}%
                                        </div>
                                        <div :style="course_info.course.sat_discount <= 0 ? 'top:18px' : ''"
                                            v-if="course_info.course.discount_obj.total_discounts"
                                            class="offer-icon institute-discount position-absolute">
                                            {{ tra.institute_discount }}
                                            -{{ formatNumber(course_info.course.discount_obj.total_discounts * 100) }}%
                                        </div>

                                        <a :href="course_info.course_link">
                                            <div class="institute-img d-inline-block position-relative">
                                                <span v-if="app_name != 'sat-edu'" class="inst-image-badge">
                                                    <img :src="public_path + 'agents-assets/' + app_name + '/imgs/logo.png'"
                                                        alt="">
                                                </span>
                                                <img :src="course_info.course_image_thumb_md ? course_info.course_image_thumb_md : public_path + 'storage/default_images.png'"
                                                    :alt="course_info.course.institute_name" class="card-img-top" />
                                            </div>
                                        </a>

                                        <div class="card-body rounded-10 bg-white">
                                            <h5 class="card-title institute-box-title">
                                                <a :href="course_info.course_link">
                                                    {{ course_info.course.institute_name }}
                                                </a>
                                            </h5>
                                            <h6 class="card-title course-box-title">
                                                <a :href="course_info.course_link">
                                                    {{ course_info.course.name }}
                                                </a>
                                            </h6>

                                            <p class="mb-0">
                                                <i class="fas fa-map-marker-alt text-main-color"></i>
                                                {{ course_info.course.country }} ,
                                                {{ course_info.course.city }}
                                            </p>
                                            <p class="mb-0 overflow-hidden d-flex justify-content-between">
                                                <span v-if="
                                                    course_info.course.study_period
                                                "><i class="fas fa-sun text-main-color"></i>
                                                    {{
                                                        course_info.course.study_period ==
                                                            "مسائي"
                                                            ? tra.afternoon
                                                            : tra.morning
                                                    }}</span>
                                                <span v-if="
                                                    course_info.course.hours_per_week !=
                                                    null
                                                ">
                                                    <i class="fas fa-clock text-main-color"></i>
                                                    {{
                                                        course_info.course.hours_per_week
                                                    }}
                                                    {{ tra.hour }}
                                                </span>
                                                <span v-else>
                                                    <i class="fas fa-book-open text-main-color"></i>
                                                    <label>{{
                                                        course_info.course.lessons_per_week
                                                    }}
                                                        {{ tra.lesson }}</label>
                                                </span>
                                                <span>
                                                    <i class="fas fa-signal text-main-color"></i>
                                                    {{
                                                        tra[course_info.course.required_level]
                                                    }}
                                                </span>
                                            </p>
                                        </div>
                                        <div v-if="course_info.total_price == course_info.total_price_before_discount"
                                            class="card-footer bg-white overflow-hidden">
                                            <span class="float-left text-main-color">
                                                {{ course_info.total_price }}
                                            </span>
                                        </div>
                                        <div v-else class="card-footer bg-white overflow-hidden">
                                            <del class="del text-danger">{{ course_info.total_price_before_discount }}
                                            </del>
                                            <span class="float-left text-main-color">
                                                {{ course_info.total_price }}
                                            </span>
                                        </div>

                                    </div>
                                </div>
                            </div>
                            <div v-else class="row">
                                <div class="col-12">
                                    <h2 class="h5 alert alert-danger">
                                        {{ tra.no_courses_found_message }}
                                    </h2>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="row px-xl-5">
                    <div class="col-12">
                        <nav aria-label="Page navigation  ">
                            <div class="row" dir="ltr">
                                <div class="col-md-auto col-12 order-md-1 order-2">
                                    <ul class="pagination d-flex justify-content-center p-0">
                                        <li>
                                            <span>
                                                <span class="page-link rounded-10 mx-1 bg-dark text-white border-0">
                                                    {{ tra.page }}
                                                    {{
                                                        courses.current_page
                                                    }}
                                                    {{ tra.of }} {{ courses.last_page }}
                                                </span>
                                            </span>
                                        </li>
                                    </ul>
                                </div>
                                <div class="col-md-auto col-12 text-center order-md-2 order-1">
                                    <ul dir="rtl" class="pagination d-flex justify-content-center p-0">

                                        <li class="page-item">
                                            <button @click="
                                                pagination(courses.first_page_url);
                                            pagination_pages_method(
                                                courses.current_page + 1
                                            );
                                            " v-if="courses.prev_page_url"
                                                class="page-link rounded-10 mx-1 text-dark border-0">
                                                <i class="fas fa-angle-double-right"></i>
                                            </button>
                                        </li>

                                        <li class="page-item">
                                            <button :style="!courses.prev_page_url
                                                ? 'background: #e4e4e4!important;color: #b5b5b5!important;cursor: not-allowed;'
                                                : ''
                                                " @click="
                                                    pagination(courses.prev_page_url);
                                                pagination_pages_method(
                                                    courses.current_page - 1
                                                );
                                                " :disabled="!courses.prev_page_url
                                                    " class="page-link rounded-10 mx-1 text-dark border-0">
                                                <i class="fas fa-chevron-right"></i>
                                            </button>
                                        </li>

                                        <li style="margin: 0 5px;" class="page-item" v-for="(page,
                                            index) in pagination_pages" :key="index" :class="courses.current_page == page
                                                ? 'active'
                                                : ''
                                                ">
                                            <a style="border-radius: 10px;" class="page-link" @click="
                                                pagination(
                                                    courses.path +
                                                    '?page=' +
                                                    page
                                                );
                                            pagination_pages_method(
                                                page
                                            );
                                            ">
                                                {{ page }}
                                            </a>
                                        </li>

                                        <li class="page-item">
                                            <button :style="!courses.next_page_url
                                                ? 'background: #e4e4e4!important;color: #b5b5b5!important;cursor: not-allowed;'
                                                : ''
                                                " @click="
                                                    pagination(courses.next_page_url);
                                                pagination_pages_method(
                                                    courses.current_page + 1
                                                );
                                                " :disabled="!courses.next_page_url
                                                    " class="page-link rounded-10 mx-1 text-dark border-0">
                                                <i class="fas fa-chevron-left"></i>
                                            </button>
                                        </li>
                                        <li class="page-item">
                                            <button @click="
                                                pagination(courses.path + `?page=${courses.last_page}`);
                                            pagination_pages_method(
                                                courses.current_page + 1
                                            );
                                            " v-if="courses.next_page_url"
                                                class="page-link rounded-10 mx-1 text-dark border-0">
                                                <i class="fas fa-angle-double-left"></i>
                                            </button>
                                        </li>

                                    </ul>
                                </div>
                            </div>
                            <div class="text-center d-lg-none d-block">
                                <button @click="newFilter()" class="btn rounded-10 bg-secondary-color text-white">
                                    {{ tra.search_again }}
                                </button>
                            </div>
                        </nav>
                    </div>
                </div>
            </div>
        </section>
    </div>
</template>

<script>
import CityComponent from "../../components/website/CityComponent.vue";
import CountryComponent from "../../components/website/CountryComponent.vue";
import DatePicker from 'primevue/datepicker';
import DiscountToggle from "../../components/website/institutes/instituts-page/discountActivationCheckbox.vue";
export default {
    props: [
        "get_courses_url_prop",
        "currencies",
        "public_path",
        "get_countries_url",
        "get_courses_categories_url",
        "get_courses_sorting_url",
        "get_cities_url",
        "apply_employee_discount_url",
        "get_employee_discount_url",
        "student_id",
        "student_check",
        "search",
        "is_admin",
        "csrf_token",
        "get_student_favourite_courses_url",
        "employee_discount",
        "active_sat_discount_url",
        "get_course_languages_url",
        "tra"
    ],
    data() {
        return {
            courses: { data: {} },
            current_page_params: "",
            keyword: "",
            country_id: "",
            country_slug: "",
            city_id: "",
            course_weeks: 1,
            best_offers: false,
            high_rated: false,
            use_params: false,
            course_level: "",
            student_favourite_courses: {},
            sorting: "",
            total_linkes: 0,
            pagination_pages: [1, 2, 3, 4, 5],
            category_type: "",
            category_intensity: "",
            study_period: "",
            course_language_id: 1,
            courses_categories: [],
            courses_sorting: [],
            course_languages: [],
            start_search: false,
            admin: this.is_admin ? JSON.parse(this.is_admin) : null,
            employee_discount_type: '',
            employee_dsicount: 0,
            remove_discount: 0,
            start_date: new Date(new Date().setDate(new Date().getDate() + 7 + (1 + 7 - new Date().getDay()) % 7)),
            residence_type: '',
            bath_type: '',
            need_residence: '',
            visa: '',
            insurance: '',
            need_airport: '',
            institute_class: '',
            budget: '',
            get_courses_url: this.get_courses_url_prop,
            filter_error_msg: this.tra ? this.tra.no_courses_found_message : 'لا توجد دورات مطابقة مع البحث الذي تجريه. يرجى تعديل مدخلات البحث والمحاولة مرة أخرى',
            countries: {},
            cities: {},
            active_sat_discount_for_user: 0,
            changeCountryId: false,
            residence_age: '',
            app_name: window.APP_NAME,
            base_url: window.base_url,
            user_details: {},
            lang: window.current_locale,
            sat_discount_loading: true,
            user_loading: true,
        };
    },
    methods: {
        onDiscountChanged() {
            this.filter_courses();
        },

        get_employee_discount: function () {
            axios.get(this.get_employee_discount_url)
                .then(response => {
                    if (response.data.discount_type) {
                        this.employee_dsicount = response.data.discount
                        this.employee_discount_type = response.data.discount_type
                    }
                });
        },
        change_employee_discount_type: function () {
            if (this.employee_discount_type == "percentage") {
                if (this.employee_dsicount > 100) {
                    this.employee_dsicount = 0;
                }
            }
        },

        pagination_pages_method: function (current_page) {
            if (current_page <= 4) {
                this.pagination_pages = [1, 2, 3, 4, 5];
            } else if (current_page > this.courses.last_page) {
                this.pagination_pages = [1, 2, 3, 4, 5];
            } else if (current_page > this.courses.last_page - 2) {
                this.pagination_pages = [
                    this.courses.last_page - 4,
                    this.courses.last_page - 3,
                    this.courses.last_page - 2,
                    this.courses.last_page - 1,
                    this.courses.last_page
                ];
            } else {
                this.pagination_pages = [
                    current_page - 2,
                    current_page - 1,
                    current_page,
                    +current_page + 1,
                    +current_page + 2
                ];
            }

            if (this.courses.last_page < 5) {
                this.pagination_pages = Array.from(
                    { length: this.courses.last_page },
                    (_, i) => i + 1
                );
            }
        },
        get_courses_categories: function () {
            axios.get(this.get_courses_categories_url)
                .then(response => {
                    this.courses_categories = response.data.data;
                });
        },

        get_course_languages: function () {
            axios.get(this.get_course_languages_url)
                .then(response => {
                    this.course_languages = response.data.data;
                });
        },


        get_courses_sorting: function () {
            axios.get(this.get_courses_sorting_url)
                .then(response => {
                    this.courses_sorting = response.data.data;
                });
        },
        get_courses: function (isFilter = false, current_page = null) {
            $(".ajax_loader").show();
            var parameters = this.params().filter_params;

            // Add SAT discount status to parameters
            parameters.active_sat_discount = this.active_sat_discount_for_user;
            parameters.app_name = this.app_name;

            if (current_page != null) {
                parameters.page = current_page;
            }
            if (isFilter) {
                parameters.start_search = true;
            }

            axios.get(this.get_courses_url, {
                params: parameters
            })
                .then(response => {
                    this.current_page_params = response.config.params;
                    this.courses = response.data.courses_data;

                    if (response.data.filter_error_msg != false) {
                        this.filter_error_msg = response.data.filter_error_msg
                    } else {
                        this.filter_error_msg = this.tra ? this.tra.no_courses_found_message : 'لا توجد دورات مطابقة مع البحث الذي تجريه. يرجى تعديل مدخلات البحث والمحاولة مرة أخرى'
                    }

                    if (isFilter) {
                        this.pagination_pages_method(this.courses.current_page);
                    } else {
                        if (this.courses.last_page < 5) {
                            this.pagination_pages = Array.from(
                                { length: this.courses.last_page },
                                (_, i) => i + 1
                            );
                        }
                    }
                    $(".ajax_loader").hide();
                    if (current_page != null) {
                        this.pagination_pages_method(current_page);
                    }
                })
                .catch(error => {
                    console.error('Error loading courses:', error);
                    $(".ajax_loader").hide();
                });
        },
        get_countries() {
            axios.get(this.get_countries_url, { params: { lang: this.lang, active_countries: 1 } })
                .then((response) => (this.countries = response.data));
        },
        get_cities(country_id) {
            axios.get(this.get_cities_url, { params: { country_id: country_id, lang: this.lang } })
                .then((response) => (this.cities = response.data));
        },
        filter_courses: function () {

            this.get_courses_url = this.courses.first_page_url;
            this.keyword = this.keyword.replace(this.tra.institute, "");
            this.start_search = true;
            this.get_courses(true);


        },
        hide_search_fields() {
            $("html, body").animate(
                { scrollTop: $("#institutes-box").offset().top - 950 },
                500
            );
            if (screen.width <= 767) {
                if ($(".toggel-filter-btn").attr("aria-expanded") == "true") {
                    $(".toggel-filter-btn").trigger("click");
                }
            }
        },
        newFilter: function () {
            if ($(".toggel-filter-btn").attr("aria-expanded") == "false") {
                $(".toggel-filter-btn").trigger("click");
                $("html, body").animate(
                    { scrollTop: $("#institutes-box").offset().top - 230 },
                    500
                );
            } else {
                $("html, body").animate(
                    { scrollTop: $("#institutes-box").offset().top - 920 },
                    500
                );
            }
        },
        pagination: function (url) {
            this.get_courses_url = url;

            this.get_courses(true);
            $("html, body").animate(
                { scrollTop: $("#institutes-box").offset().top - 950 },
                500
            );
            if (screen.width <= 767) {
                if ($(".toggel-filter-btn").attr("aria-expanded") == "true") {
                    $(".toggel-filter-btn").trigger("click");
                }
            }
        },
        student_login_message: function () {
            if (!this.student_check) {
                alert("يجب عليك تسجيل الدخول اولا");
            }
        },
        institute_rate: function (institute_obj) {
            if (institute_obj.rate_switch == 1) {
                return institute_obj.sat_rate;
            } else {
                if (institute_obj.rats[0] == null) {
                    return 5;
                } else {
                    var students_rate = 0;
                    var arr_length = institute_obj.rats.length;
                    var rate_avg = 0;
                    institute_obj.rats.forEach(element => {
                        students_rate += element.rate;
                    });
                    rate_avg = students_rate / arr_length;
                    return Math.round(rate_avg);
                }
            }
        },
        course_price_per_week(prices_obj) {
            var price_per_week = 0;
            prices_obj.every(week_price => {
                price_per_week = week_price.price;
                if (this.course_weeks <= week_price.weeks) {
                    price_per_week = week_price.price;
                    return false;
                } else {
                    return true;
                }
            });
            return price_per_week;
        },
        params: function () {
            var filter_params = {
                start_search: this.start_search,
                keyword: this.keyword.replace(this.tra.institute, ""),
                country_id: this.country_id,
                country_slug: this.country_slug,
                city_id: this.city_id,
                course_weeks: this.course_weeks,
                best_offers: this.best_offers,
                course_level: this.course_level,
                student_id: this.student_id,
                sorting: this.sorting,
                category_type: this.category_type,
                category_intensity: this.category_intensity,
                study_period: this.study_period,
                course_language_id: this.course_language_id,
                start_date: this.formatDate(this.start_date),
                need_residence: this.need_residence,
                residence_type: this.residence_type,
                bath_type: this.bath_type,
                visa: this.visa,
                insurance: this.insurance,
                need_airport: this.need_airport,
                institute_class: this.institute_class,
                budget: this.budget,
            };
            var pagination_params =
                "&keyword=" + this.keyword.replace(this.tra.institute, "");
            return {
                filter_params: filter_params,
                pagination_params: pagination_params
            };
        },
        formatNumber: function (number) {
            if (Number.isInteger(number)) {
                return number.toString();
            } else {
                return number.toFixed(1);
            }
        },
        copyPageLink: function () {
            let url = this.public_path + "institutes?";
            for (const [p, val] of Object.entries(this.current_page_params)) {
                if (!(val == "" || val == undefined)) {
                    url += `${p}=${val}&`;
                }
            }
            url = url.substring(0, url.length - 1);
            navigator.clipboard.writeText(url);
        },
        handleKeyUp(event) {
            if (event.keyCode === 13) {
                this.filter_courses();
                this.pagination_pages_method(this.courses.current_page);
            }
        },
        active_sat_discount: function () {
            axios.post(this.active_sat_discount_url, {
                active_sat_discount_for_user: this.active_sat_discount_for_user
            }, {
                headers: {
                    "X-CSRFToken": this.csrf_token,
                    "Content-Type": "application/json"
                }
            })
                .then(response => {
                    // Refresh courses after discount change
                    this.filter_courses();
                })
                .catch(error => {
                    console.error('Error updating SAT discount:', error);
                });
        },
        get_user_details: function () {
            this.user_loading = true;
            axios.get(this.base_url + '/get-user-details')
                .then(response => {
                    this.user_details = response.data.user;
                    this.user_loading = false;
                    // Check SAT discount after user details are loaded
                    this.checkAndSetSatDiscount();
                })
                .catch(error => {
                    console.error('Error loading user details:', error);
                    this.user_loading = false;
                });
        },
        checkAndSetSatDiscount: function () {
            if (this.app_name !== 'sat-edu') {
                this.active_sat_discount_for_user = false;
                return;
            }

            if (this.admin && this.user_details) {
                // Check if user is admin or employee with SAT discount permission
                const isAdmin = this.user_details.roles && this.user_details.roles.includes('admin');
                const isEmployee = this.user_details.roles && this.user_details.roles.includes('employee');

                if (isAdmin || isEmployee) {
                    this.active_sat_discount_for_user = this.admin.active_sat_discount == 1;
                } else {
                    this.active_sat_discount_for_user = true; // Default for regular users
                }
            }
        },
        checkEmployeeDiscount: function () {
            if (this.user_details && this.user_details.roles && this.user_details.permissions &&
                (this.user_details.roles.includes('admin') || this.user_details.permissions.includes('employee-discount-create'))) {
                return true;
            }
            else {
                return false;
            }
        }
    },
    watch: {
        need_residence: function () {
            if (this.need_residence == '' || this.need_residence == 'no') {
                this.residence_type = '';
                this.bath_type = '';
            }
        },
        cities: function () {

        },
        keyword: function () {
            this.filter_courses();
            this.pagination_pages_method(this.courses.current_page);
        },
        country_id: function () {
            this.get_cities(this.country_id)
            this.filter_courses();
            this.pagination_pages_method(this.courses.current_page);

            if (this.changeCountryId) {
                this.city_id = ''
            }
        },
        city_id: function () {
            this.filter_courses();
            this.pagination_pages_method(this.courses.current_page);
        },
        course_weeks: function () {
            this.filter_courses();
            this.pagination_pages_method(this.courses.current_page);
        },
        start_date: function () {
            this.filter_courses();
            this.pagination_pages_method(this.courses.current_page);
        },
        need_residence: function () {
            if (this.need_residence == '') {
                this.residence_type = ''
                this.bath_type = ''
            }
            this.filter_courses();
            this.pagination_pages_method(this.courses.current_page);
        },
        residence_type: function () {

            this.filter_courses();
            this.pagination_pages_method(this.courses.current_page);
        },
        bath_type: function () {
            this.filter_courses();
            this.pagination_pages_method(this.courses.current_page);
        },
        insurance: function () {
            this.filter_courses();
            this.pagination_pages_method(this.courses.current_page);
        },
        need_airport: function () {
            this.filter_courses();
            this.pagination_pages_method(this.courses.current_page);
        },
        category_type: function () {
            this.filter_courses();
            this.pagination_pages_method(this.courses.current_page);
        },
        category_intensity: function () {
            this.filter_courses();
            this.pagination_pages_method(this.courses.current_page);
        },
        study_period: function () {
            this.filter_courses();
            this.pagination_pages_method(this.courses.current_page);
        },
        course_language_id: function () {
            this.filter_courses();
            this.pagination_pages_method(this.courses.current_page);
        },
        visa: function () {
            this.filter_courses();
            this.pagination_pages_method(this.courses.current_page);
        },
        sorting: function () {
            this.filter_courses();
            this.pagination_pages_method(this.courses.current_page);
        },

    },
    computed: {

    },
    mounted() {
        window.addEventListener('keyup', this.handleKeyUp);
        if ($(window).width() < 767) {
            $('.collaps-at-md').attr('id', 'moreOptions').addClass("collapse");
        }
        this.get_user_details();
    },
    beforeDestroy() {
        window.removeEventListener('keyup', this.handleKeyUp);

    },
    beforeMount() {
        this.get_countries()
        this.get_courses_categories()
        this.get_courses_sorting()
        this.get_course_languages()
        this.get_employee_discount()
        this.get_user_details()

        if (this.admin) {
            this.admin.active_sat_discount == 1 ? this.active_sat_discount_for_user = true : this.active_sat_discount_for_user = false
        }

        this.total_linkes = this.courses.last_page - this.courses.current_page;

        if (this.search.length != 0) {
            if (this.search.keyword != undefined) {
                this.keyword = this.search.keyword.replace(this.tra.institute, "");
            }
            if (this.search.country_id != undefined) {
                this.country_id = +this.search.country_id;
            }
            if (this.search.city_id != undefined) {
                this.city_id = +this.search.city_id;
            }
            if (this.search.course_weeks != undefined) {
                this.course_weeks = this.search.course_weeks;
            }
            if (this.search.course_level != undefined) {
                this.course_level = this.search.course_level;
            }
            if (this.search.sorting != undefined) {
                this.sorting = this.search.sorting;
            }
            if (this.search.start_date != undefined) {
                this.start_date = this.search.start_date;
            }
            if (this.search.residence_type != undefined) {
                this.residence_type = this.search.residence_type;
            }
            if (this.search.bath_type != undefined) {
                this.bath_type = this.search.bath_type;
            }
            if (this.search.need_residence != undefined) {
                this.need_residence = this.search.need_residence;
            }
            if (this.search.visa != undefined) {
                this.visa = this.search.visa;
            }
            if (this.search.insurance != undefined) {
                this.insurance = this.search.insurance;
            }
            if (this.search.need_airport != undefined) {
                this.need_airport = this.search.need_airport;
            }
            if (this.search.category_type != undefined) {
                this.category_type = this.search.category_type;
            }
            if (this.search.category_intensity != undefined) {
                this.category_intensity = this.search.category_intensity;
            }
            if (this.search.study_period != undefined) {
                this.study_period = this.search.study_period;
            }
            if (this.search.course_language_id != undefined) {
                this.course_language_id = +this.search.course_language_id;
            }
            $(document).ready(function () {
                $("html, body").animate(
                    { scrollTop: $("#institutes-box").offset().top - 1050 },
                    500
                );
                if (screen.width <= 767) {
                    $(".toggel-filter-btn").trigger("click");
                }
            });
            this.get_courses(true, this.search.page, true);


        } else {
            this.get_courses();
        }
    },
    computed: {},
    components: {
        CityComponent,
        CountryComponent,
        DatePicker,
        DiscountToggle
    }
};
</script>